import { render, staticRenderFns } from "./External.vue?vue&type=template&id=a5a4f3b8&scoped=true"
import script from "./External.vue?vue&type=script&lang=ts"
export * from "./External.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a4f3b8",
  null
  
)

export default component.exports